import React from 'react';

import Advantages from '@app/components/Pages/Resources/VetResources/CentralStaticInfo/Advantages';
import BlockWithMap from '@app/components/Pages/Resources/VetResources/CentralStaticInfo/BlockWithMap';
import SectionForms from '@app/components/Pages/Resources/VetResources/CentralStaticInfo/SectionForms';

import '@app/scss/components/centralStaticInfo.scss';

interface Props {
	loginRef: any;
	signupRef: any;
}

const CentralStaticInfo: React.FC<Props> = ({ loginRef, signupRef }) => {
	return (
		<div className="central-static-info">
			<BlockWithMap />
			<Advantages />
			<SectionForms loginRef={loginRef} signupRef={signupRef} />
		</div>
	);
};

export default CentralStaticInfo;
